<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 26L7 16L24 6L24 26Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'ChevronLeft' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
